import type { ReactNode } from 'react';
import { useLocation, type To } from 'react-router-dom';
import { platformReportGroups } from './reportGroups';

/** The sidebar's links to each dashboard, rendered only while one is open. */
export const DashboardSubLinks = ({
  children,
}: {
  children: (links: { name: string; to: To }[]) => ReactNode;
}) => {
  // moving between dashboards keeps the date and filters chosen
  const { search } = useLocation();

  return children(
    platformReportGroups.map(({ key, label }) => ({
      name: label,
      to: { pathname: `/dashboards/${key}`, search },
    })),
  );
};
